(() => {
  document.addEventListener('click', async (event) => {
    const fullscreenButton = event.target.closest('[data-editorial-fullscreen]');
    if (fullscreenButton) {
      const media = fullscreenButton.closest('[data-editorial-media]');
      if (!media) return;

      try {
        if (document.fullscreenElement) {
          await document.exitFullscreen();
        } else if (media.requestFullscreen) {
          await media.requestFullscreen();
        }
      } catch (_) {
        // Fullscreen may be unavailable in embedded theme previews.
      }
      return;
    }

    const shareButton = event.target.closest('[data-editorial-share]');
    if (!shareButton) return;

    try {
      if (navigator.share) {
        await navigator.share({ title: document.title, url: window.location.href });
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(window.location.href);
        shareButton.classList.add('is-copied');
        shareButton.setAttribute('aria-label', 'Link copiado');
        window.setTimeout(() => {
          shareButton.classList.remove('is-copied');
          shareButton.setAttribute('aria-label', 'Compartilhar produto');
        }, 1800);
      }
    } catch (_) {
      // The visitor can dismiss the native share dialog without an error state.
    }
  });
})();
